// Copyright 2025 Sorama B.V.

import { Point3D } from "datatypes/SoramaWebApi";
import { IWorkflowPropertyParser } from "libraries/WorkflowFramework/Interfaces/IWorkflowPropertyParser";

export class Point3DParser implements IWorkflowPropertyParser<Point3D> {
    private static readonly precision = 5;

    toWorkflowProperty(object: Point3D): string {
        if (object == undefined || object.x == undefined || object.y == undefined || object.z == undefined) {
            return "";
        }

        return (
            object.x.toFixed(Point3DParser.precision) +
            "," +
            object.y.toFixed(Point3DParser.precision) +
            "," +
            object.z.toFixed(Point3DParser.precision)
        );
    }

    fromWorkflowProperty(str: string): Point3D {
        const vals = str.split(",");
        return <Point3D>{
            x: Number(vals[0]),
            y: Number(vals[1]),
            z: Number(vals[2]),
        };
    }
}
